import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
export const fieldsLogin = _extends({}, fieldsIBaseModel, {
  ip: {
    type: 'Text'
  }
});